module.exports = __webpack_public_path__ + "img/eff04small.bc772d79.png";